interface states {
  State: string;
  Value: number;
}

export const LIS_States: states[] = [
  {
    State: 'Pendiente',
    Value: 1,
  },
  {
    State: 'Con resultado',
    Value: 2,
  },
  {
    State: 'Validado',
    Value: 3,
  },
  {
    State: 'Impreso',
    Value: 4,
  },
  {
    State: 'En otras fuentes',
    Value: 5,
  },
];

export const Analitos_ResultsTypes: states[] = [
  {
    State: 'Numérico',
    Value: 1,
  },
  {
    State: 'Textual',
    Value: 2,
  },
  {
    State: 'Fórmula',
    Value: 3,
  },
  {
    State: 'Plantilla',
    Value: 4,
  },
  {
    State: 'Fecha',
    Value: 5,
  },
  {
    State: 'Tiempo',
    Value: 6,
  },
  {
    State: 'Imagen',
    Value: 7,
  },
  {
    State: 'Lista',
    Value: 8,
  },
  {
    State: 'Microbiología',
    Value: 9,
  },
  {
    State: 'Autocompletar',
    Value: 10,
  },
  {
    State: 'Multilínea',
    Value: 11,
  },
  {
    State: 'Imágenes DX',
    Value: 12,
  },
];

export const GroupsConfigurations: any[] = [
  {
    text: 'GENERAL ',
    Value: 1,
  },
  {
    text: 'ADMIN CACHÉ',
    Value: 2,
  },
  {
    text: 'DISEÑOS',
    Value: 3,
  },
  {
    text: 'ÓRDENES',
    Value: 4,
  },
  {
    text: 'RESULTADOS',
    Value: 5,
  },
  {
    text: 'MÓDULOS',
    Value: 6,
  },
  // {
  //   text: 'GN. MÓDULOS',
  //   Value: 7,
  // },
  // {
  //   text: 'REPORTES',
  //   Value: 8,
  // },
  {
    text: 'SERVICIOS',
    Value: 9,
  },
];

export const GroupsConfigurationsWebPageResults: any[] = [
  {
    text: 'PACIENTES',
    Value: 1,
  },
  {
    text: 'CENTROS',
    Value: 2,
  },
  {
    text: 'GENERAL',
    Value: 3,
  },
];